import _classCallCheck from "/drone/src/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/drone/src/node_modules/@babel/runtime/helpers/esm/createClass";
import { DateVector } from './DateVector';
export var DateVectorRange = /*#__PURE__*/function () {
  function DateVectorRange() {
    var dateStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var dateEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, DateVectorRange);

    this.dateStart = dateStart;
    this.dateEnd = dateEnd;
  }

  _createClass(DateVectorRange, [{
    key: "clone",
    value: function clone() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          dateStart = _ref.dateStart,
          dateEnd = _ref.dateEnd;

      var ownDateStart = this.dateStart,
          ownDateEnd = this.dateEnd;
      var effectiveDateStart = dateStart || ownDateStart || null;
      var effectiveDateEnd = dateEnd || ownDateEnd || null;
      return new DateVectorRange(effectiveDateStart ? effectiveDateStart.clone() : null, effectiveDateEnd ? effectiveDateEnd.clone() : null);
    }
  }, {
    key: "convertToLocalDateRange",
    value: function convertToLocalDateRange(timeVector) {
      var dateStart = this.dateStart,
          dateEnd = this.dateEnd;
      var time = {};

      if (timeVector) {
        time = {
          hour: timeVector.hour,
          minute: timeVector.minute
        };
      }

      var start;

      if (dateStart) {
        start = dateStart.clone(time).convertToLocalDate();
      }

      var end;

      if (dateEnd) {
        end = dateEnd.clone(time).convertToLocalDate();
      }

      return [start, end];
    }
  }, {
    key: "convertToLocalDate",
    value: function convertToLocalDate(timeVector) {
      var dateStart = this.dateStart;
      var time = {};

      if (timeVector) {
        time = {
          hour: timeVector.hour,
          minute: timeVector.minute
        };
      }

      var start;

      if (dateStart) {
        start = dateStart.clone(time).convertToLocalDate();
      }

      return start;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !this.dateStart || !this.dateEnd;
    }
  }, {
    key: "isNarrow",
    value: function isNarrow() {
      var _a;

      return (_a = this.dateEnd) === null || _a === void 0 ? void 0 : _a.isEqualTo(this.dateStart);
    }
  }], [{
    key: "createFromLocalDateRange",
    value: function createFromLocalDateRange(dateRange) {
      if (!dateRange) {
        return new this();
      }

      return new this(dateRange[0] ? DateVector.createFromLocalDate(dateRange[0]) : null, dateRange[1] ? DateVector.createFromLocalDate(dateRange[1]) : null);
    }
  }, {
    key: "createFromLocalDate",
    value: function createFromLocalDate(date) {
      if (!date) {
        return new this();
      }

      return new this(date ? DateVector.createFromLocalDate(date) : null, date ? DateVector.createFromLocalDate(date) : null);
    }
  }]);

  return DateVectorRange;
}();